import React from 'react';
import MainHeading from '../Common/MainHeading';
import { useLocale } from '../../localization/LocaleContext';

const benefits= [
    {
        id:0,
        key:'noRiskPolicy',
        imgURL:"/images/Group 80.png",
    },
    {
        id:1,
        key:'moneyBackGuarantee',
        imgURL:"/images/Group 81.png",
    },
    {
        id:2,
        key:'support',
        imgURL:"/images/Group 82.png",
    },
      
]

function PriceBenefits() {
    const { t } = useLocale();

    return(
        <section className="Benefits sp-90">
        <MainHeading headingName={t('pricing.benefitsHeading')} />
        <div className="container spt-60">
            <div className="row">
                {benefits.map((i => (
                    <div className="col-lg-4" key={i.id}>
                        <div className="p-30-40 flex-center-align flex-column benefit-box br-5 mb-30">
                            <img src={i.imgURL} className="mb-10" alt="img" />
                            <h3 className="h-3 fw-600 mb-10">
                                {t(`pricing.benefits.${i.key}.name`)}
                            </h3>
                            <p className="paragraph p-adjustment">
                                {t(`pricing.benefits.${i.key}.description`)}
                            </p>
                        </div>
                    </div>
                )))}
            </div>
        </div>
    </section>
    )
}

export default PriceBenefits;